<template>
	<div class="survey-layout">
        <!-- Loading -->
        <v-card v-if="loading" height="81vh" elevation="0" color="transparent"  class="d-flex flex-column justify-space-between align-center" >
            <v-row>
                <v-col align-self="center">
                    <v-progress-circular
                        size="50"
                        indeterminate
                        color="white"
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </v-card>

        <!-- survey -->
        <div class="survey-layout-container" v-if="!loading" >
            <v-form ref="form" @submit.prevent="save">
                <v-row justify="center" >
                    <v-col class="text-left ">
                        <div class="font-weight-bold body-1 mb-1">
                            {{surveyTitle}}
                        </div>
                    </v-col>
                    <v-col v-if="previewMode" cols="12" sm="6"  class="text-right mb-4 mb-sm-0 d-none d-sm-inline">
                        <iconButton :props="returnBtn" class=""></iconButton>  
                    </v-col>
                </v-row>
                <div class="survey-layout-subtext mb-4 mb-sm-8 ">
                    {{surveyInstructions}}
                </div>

                <v-row v-if="previewMode" class="d-inline d-sm-none my-0">
                    <v-col cols="12" sm="6"  class="text-right py-0 mb-sm-0">
                        <iconButton :props="returnBtn" class=""></iconButton>  
                    </v-col>
                </v-row>
                
                <Form
                    :values="form"
                    :serverErrors="serverErrors"
                    :key="formKey"
                    :previewMode="previewMode"
                ></Form>
            </v-form>
            

            <v-row justify="center" align="end" v-if="!previewMode">
				<v-col cols="12"  class="pt-9">
                    <v-row justify="end" class="px-3 py-3">
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </div>
        <div class="survey-layout-footer" v-if="!loading">
            <app-footer class="mt-5 "></app-footer>

        </div>
	</div>
</template>

<script>
import AppFooter from "../components/AppFooter.vue";
import Object2Form from '../helpers/Object2Form';
import Form from "../views/managerViews/rrhh/questionnaires/QuestionnaireForm.vue";
import Utils from '../helpers/Utils';
// import VueGatesPlugin from '../plugins/vue-gates';
	export default {
		name: 'survey-layout',
		components: {
            AppFooter,
            Form
		},
        data() {
            return {
                surveyTitle: "",
                formKey:83,
                icon:"",
                surveyId: this.$route.params.surveyId,
                employeeId: this.$route.params.employeeId,
                previewMode: false,
                employeeName: "あ",
                employeeNumber: "え",
                employeeCompany: "い",
                surveyInstructions:"",
                loading:true,
                toggleItemsRank:[
                    {text: "deficiente", value: "deficiente"},
                    {text: "mala", value: "mala"},
                    {text: "regular", value: "regular"},
                    {text: "buena", value: "buena"},
                    {text: "excelente", value: "excelente"},
                ],
                toggleItemsYesNo:[
                    {text: "Si", value: "Si"},
                    {text: "No", value: "No"},
                ],
                serverErrors:{},
                form:{
                    survey_id:this.$route.params.surveyId,
                    employee_id: this.$route.params.employeeId,
                    questions: [
                        // {
                        //     id: + new Date(),
                        //     type: "",
                        //     required: false,
                        //     question: "",

                        //     //binary & multi use
                        //     add_not_apply: "",

                        //     //multi use
                        //     add_other:"",
                        //     option_list:[{option:""}],

                        //     //binary use
                        //     to_list: [],

                        //     //scalar use
                        //     start_tag: '',
                        //     end_tag: '',

                        //     //number use
                        //     unit: ""
                        // }
                    ]
                },

                rules: {
                    required: [
                        v => {
                            if(v == null || v == undefined)
                                return "Campo requerido";
                            try {
                                if(v.trim() == "")
                                    return "Campo requerido";
                            } catch (error) {
                                console.log(error);
                            }
                            return true;
                        }
                    ],
                },
                saveBtnData: {
                    text: "Enviar mis respuestas",
                    icon: "mdi-send-outline",	
                    click: this.save,
                    block:true,
                    loading: false,
                },
                returnBtn:{
                    text: "",
                    icon: "mdi-arrow-left",	
                    click: this.back,
                    block:false,
                    loading: false,
                    height:'35',
                    color:'primary'
                }
            }
        },
        computed: {
            routeName: {
                get: function() {
                    if(this.$route.name != 'Login')
                        return true;
                    return false;
                }
               
            },
            
        
        },
        mounted(){
            console.log(this.$gates.hasPermission('employee_site.show'), "el permiso", this.employeeId, this.$gates.hasPermission('surveys.show'))
            window.addEventListener('resize', this.onResize, { passive: true });
            this.onResize();
           
            this.$store.state.layout = 'Questionnaire';

            //check preview mode
            if(this.employeeId == "preview"){
                if(this.$gates.hasPermission('surveys.show')){
                    this.previewMode = true;
                }
                // else{
                //     this.$router.push(`/`);
                // }
            }

            if(this.$gates.hasPermission('employee_site.show')){
                this.indexEmployeeSide();
                return;
            }
            this.index();
        },
        methods: {
            back(){
                this.$store.state.layout = 'dashboard';
                this.$router.push({name: 'Questionary'});
            },
            validate () {
                const status = this.checkManualValidatios();
                // this.$refs.form.validate();
                this.$nextTick(() => {
                 this.formKey = this.formKey + 1;
                });
                return status;
            },
            checkManualValidatios(){
                let valid = true;
                for (let i = 0; i < this.form.questions.length; i++) {

                    //required validation
                    if(this.form.questions[i].required && (this.form.questions[i].type != 'scale' && this.form.questions[i].type != 'upload_image')){
                        if(this.form.questions[i].response == undefined || this.form.questions[i].response.trim() == ""){
                            this.serverErrors[`q_${i}`] = "Campo requerido";
                            valid = false;
                        }
                    }else  if(this.form.questions[i].required && (this.form.questions[i].type == 'scale' || this.form.questions[i].type == 'upload_image')){
                        if(this.form.questions[i].response == null || this.form.questions[i].response.length == 0){
                            this.serverErrors[`q_${i}`] = "Campo requerido";
                            valid = false;
                        }
                    }

                    //numeric
                    if(this.form.questions[i].type == 'number'){
                        if(this.form.questions[i].response != null && this.form.questions[i].response != ""){
                            if (this.form.questions[i].response != null && !this.form.questions[i].response.match("^[0-9]+(.[0-9]{1,9})?$"))
                                this.serverErrors[`q_${i}`] = "Solo números";
                        }
                    }
                    

                    
                }
                // 
                //
                // this.formKey++;
                return valid;
            },
            onResize () {
            
                if(window.innerWidth < 600){
                    this.saveBtnData.block = true;
                    this.returnBtn.block = true;
                }
                else{
                    this.saveBtnData.block = false;
                     this.returnBtn.block = false;
                }
            },
            onActionConfirmed() {
                setTimeout(() => {
                    this.$refs.swipeButtonrl.reset();
                }, 1000);
            },
            setForm(data){
                this.surveyTitle = data.name;
                this.surveyInstructions = data.instructions??"";
                this.form.questions = data.questions.map((x,index) =>{
                    x.question = `${index + 1}.- ${x.question}`;
                    x["response"] = "";
                    if(x.type == "upload_image"){
                        x["response"] = [];
                    }
                    if(x.type == "scale"){
                        x["response"] = 2;
                    }
                    if(x.type == "time"){
                        x["response"] = undefined;
                    }
                    // if(x.type == 'multi'){
                    //     if(x.add_not_apply){
                    //         x.option_list.push({option: 'no aplica'});
                    //     }
                    //     if(x.add_other){
                    //         x.option_list.push({option: 'otro'});
                    //     }
                    // }
                    return x;
                });
            },
            indexEmployeeSide()
            {
                //this.$store.state.overlay = true
                this.loading = true;
                this.$api.employeeSurvey.getBody(this.surveyId)
                    .then((response) => {
                        this.setForm(response.data)
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading = false;
                        // this.$refs.form.reset();
                    })
            },

            index(){
                //this.$store.state.overlay = true
                this.loading = true;
               this.$api.questionaries.get(this.surveyId)
                .then((response) => {
                    this.setForm(response.data);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    // this.$refs.form.reset();
                })
            },

            save(){
                this.saveBtnData.loading = true;
                // console.log(this.prepareRequest(this.form), "formmmm");
                if(this.validate()){
                    let request = this.prepareRequest(this.form);
                    let response = {};
                    if(this.$gates.hasPermission('employee_site.show')){
                        response = this.$api.employeeSurvey.sendAnswers(this.surveyId, request)
                    }else{
                        response = this.$api.questionaries.saveAnswers(this.surveyId, request)
                    }
                    
                    // let form = JSON.parse(JSON.stringify(this.form))
                   
                    response
                        .then(() => {
                            // this.$router.push({name: 'Questionary'});
                            this.$router.push({name: 'surveyThanks'});
                        })
                        .catch((error) => {
                            console.log(error.response)
                            var errors = []
                            switch(error.response.status){
                                case 400: 
                                    //console.log(99, error.response);
                                    if(("message" in error.response.data)){
                                        Object.keys(error.response.data.message).forEach((x) => {
                                            //console.log(x);
                                            // for (const [key, value] of Object.entries(object1)) {
                                            //     console.log(`${key}: ${value}`);
                                            // }
                                            this.serverErrors = error.response.data.message;
                                            const keyValue = x.split(".")
                                            error.response.data.message[x].forEach((y) => {
                                                this.serverErrors[`q_${keyValue[1]}`] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                        this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                    }
                                
                                break;
                            
                            }

                            console.log(this.serverErrors)
                        
                        })
                        .finally(() => {
                            this.saveBtnData.loading = false;
                        })
                    ;
                }else{
                    this.saveBtnData.loading = false;
                    this.$store.dispatch('snackbarError', `Formulario inválido`);
                   
                }
            },

            prepareRequest(request){
                let data = JSON.parse(JSON.stringify(request));

                data["answers"] = [];

                for (let i = 0; i < data.questions.length; i++) {
                    let item = data.questions[i];

                    if(item.type == "upload_image"){
                        data.answers.push({
                            question_id: item.id,
                            answer_value: request.questions[i].response.map((x) => {
                                return {file: x}
                            }),
                        })
                    }else
                    if(item.type == "binary"){
                        data.answers.push({
                            question_id: item.id,
                            answer_value: item.response == "Si" ? true : (item.response == "No" ? false : "na")
                        });
                    }else{
                         data.answers.push({
                            question_id: item.id,
                            answer_value: item.response,
                        });
                    }

                }

                delete data.questions;

                return Object2Form.objectToFormData(data, "", []);
            }
        },
	}
</script>

<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
    
    .survey-layout{
        background-color: #18585B;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        padding: 3rem 0px;
        
        &-container{
            background-color: white;
            width: 85%;
            padding: 2rem 7rem;

            @media (max-width: #{map-get($grid-breakpoints, 'xl')}) {
                padding: 2rem 5.5rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'lg')}) {
                padding: 2rem 2rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'md')}) {
                padding: 2rem 1rem;
                width: 95%;
                
            }
        }


        &-subtext{
            font-size: 0.75rem;
            font-weight: 500;
            line-height: 1rem !important;
        }

        &-form-input{
            label{
                font-size: .8rem !important;
            }
        }

        &-footer{
            align-self: flex-start;
            width: 85%;
            padding: 0rem 8rem ;
            .footer-text{
                color: white !important;
            }
            .footer-icon{
                // width: 200px;
                // height: 200px;
                filter: invert(100%) sepia(10%) saturate(7459%) hue-rotate(279deg) brightness(118%) contrast(108%);
            }
            @media (max-width: #{map-get($grid-breakpoints, 'xl')}) {
                padding: 0rem 7rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'lg')}) {
                padding: 0rem 5rem;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'md')}) {
                padding: 0rem 1rem;
                width: 95%;
                
            }
        }

        
    }
	
</style>